function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js'; // import { colors as c } from '@app/css';

const colors = {
  green: '#daf0ed',
  red: '#f9c3c7',
  grey: '#b0b2b9',
  density: '#4D525B'
};

function SvgComponent({
  color,
  height,
  size,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size || width,
    height: size || height,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("rect", {
    x: ".5405",
    width: "8.4073",
    height: ".7643",
    rx: ".3821",
    transform: "rotate(45 .5405 0)",
    fill: colors[color]
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6.4854",
    y: ".5405",
    width: "8.4073",
    height: ".7643",
    rx: ".3821",
    transform: "rotate(135 6.4854 .5405)",
    fill: colors[color]
  }));
}

SvgComponent.defaultProps = {
  color: 'green',
  width: 11,
  height: 11
};
SvgComponent.propTypes = {
  color: PropTypes.oneOf(['green', 'red', 'grey', 'density']),
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;